import { VisuallyHidden } from '@react-aria/visually-hidden';
import styled from 'styled-components/macro';

import { Button } from '@src/components/Button';

const Container = styled.div`
  position: fixed;
  right: 0;
  bottom: 0;
  margin: var(--space-4);
  padding: var(--space-4);
  border: 1px solid var(--color-gray-3);
  border-radius: var(--radius-md);
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  background-color: var(--color-white);
  box-shadow: var(--shadow-xl);
`;

export interface ReloadPromptProps {
  needsRefresh: boolean;
  onClick: () => void;
}

/** The UI for the service worker updater mechanism. */
export function ReloadPrompt({ needsRefresh, onClick }: ReloadPromptProps) {
  return (
    <>
      <VisuallyHidden>
        <div role="status" aria-live="polite">
          {needsRefresh && 'A new version of the app is available.'}
        </div>
      </VisuallyHidden>
      {needsRefresh && (
        <Container>
          <p>New content available.</p>
          <Button type="button" variant="primary" onClick={onClick}>
            Update
          </Button>
        </Container>
      )}
    </>
  );
}
